import { toReadableNumber } from 'app/shared/utils/number';

export const determineRules = (datatype = 'string') => {
  const rules_by_type = {
    array: [
      { label: 'Contains', value: '$in' },
      { label: 'Does Not Contain', value: '$nin' }
    ],
    boolean: [
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ],
    date: [
      { label: 'On', value: '$on' },
      { label: 'Before', value: '$before' },
      { label: 'After', value: '$after' },
      { label: 'Over', value: '$min' },
      { label: 'Less than', value: '$max' }
    ],
    event: [
      { label: 'Invoked', value: '$in' },
      { label: 'Not Invoked', value: '$nin' }
    ],
    exist: [
      { label: 'Is Present', value: 'true' },
      { label: 'Is Not Present', value: 'false' }
    ],
    number: [
      { label: 'Equal to', value: '$eq' },
      { label: 'Not equal to', value: '$ne' },
      { label: 'Greater than', value: '$gt' },
      { label: 'Less than', value: '$lt' }
    ],
    string: [
      { label: 'Contains', value: '$in' },
      { label: 'Starts With', value: '$start' },
      { label: 'Ends With', value: '$end' },
      { label: 'Matches Exactly', value: '$exact' },
      { label: 'Does Not Contain', value: '$not_in' },
      { label: 'Does Not Start With', value: '$not_start' },
      { label: 'Does Not End With', value: '$not_end' },
      { label: 'Does Not Match Exactly', value: '$not_exact' }
    ]
  };

  return rules_by_type[datatype];
};

export const determineValueLabel = (datatype, rule) => {
  switch (datatype) {
    case 'array':
      return rule === '$in' ? 'contains' : 'does not contain';
    case 'boolean':
      return rule === 'true' ? 'is true' : 'is false';
    case 'date':
      switch (rule) {
        case '$on':
          return 'occurred on';
        case '$before':
          return 'occurred before';
        case '$after':
          return 'occurred after';
        case '$min':
          return 'occurred over';
        case '$max':
          return 'occurred less than';
      }
      break;
    case 'event':
      return rule === '$in' ? 'is invoked with the event:' : 'is not invoked with the event:';
    case 'number':
      switch (rule) {
        case '$eq':
          return 'equal to';
        case '$ne':
          return 'not equal to';
        case '$gt':
          return 'greater than';
        case '$lt':
          return 'less than';
      }
      break;
    default:
      switch (rule) {
        case '$in':
          return 'contains';
        case '$start':
          return 'starts with';
        case '$end':
          return 'ends with';
        case '$exact':
          return 'is';
        case '$not_in':
          return 'does not contain';
        case '$not_start':
          return 'does not start with';
        case '$not_end':
          return 'does not end with';
        case '$not_exact':
          return 'is not';
      }
  }
};

export const processNeedleValue = (datatype, rule, value) => {
  switch (datatype) {
    case 'array':
      return value.split(',').map((item) => item.trim());
    case 'boolean':
      return value === 'true';
    case 'date':
      switch (rule) {
        case '$on':
        case '$before':
        case '$after':
          return new Date(value).toLocaleDateString();
        case '$min':
          return `${value.split(':')[0]} ${value.split(':')[1]} ago`;
        case '$max':
          return `${value.split(':')[0]} ${value.split(':')[1]} ago`;
      }
      break;
    case 'event':
      return value.split(':')[0];
    case 'number':
      return toReadableNumber(Number(value));
    default:
      return value;
  }
};
